import { render, staticRenderFns } from "./CompanyModule.vue?vue&type=template&id=c18e6be8&scoped=true"
import script from "./CompanyModule.vue?vue&type=script&lang=js"
export * from "./CompanyModule.vue?vue&type=script&lang=js"
import style0 from "./CompanyModule.vue?vue&type=style&index=0&id=c18e6be8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18e6be8",
  null
  
)

export default component.exports